module.exports = __webpack_public_path__ + "static/media/logout.845a1221.svg";